<kendo-formfield>
    <kendo-label *ngIf="!!caption" [text]="caption | translate"></kendo-label>
    <kendo-combobox #listCombo [ngClass]="{'fx-fill': settings.fxFill}" [data]="valuesList$ | async"
        [valuePrimitive]="true" [formControl]="control" [filterable]="true" [allowCustom]="allowCustom"
        (valueChange)="onChange($event)" (filterChange)="filterChange($event)" [readonly]="settings.readonly">

        <ng-template kendoDropDownListNoDataTemplate>
            <div *ngIf="!(term$|async)">{{'kendo.combobox.startTyping' | translate}}</div>
            <div *ngIf="term$|async">{{'kendo.combobox.noMatch' | translate}}</div>
        </ng-template>
    </kendo-combobox>
</kendo-formfield>
